var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton, RadioButton, Text, Divider, Headline, Icon, } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../../components/DangerousElement';
import { useServicesContext, useStockContext } from '../../../../../context';
import { trackClick, trackUpdateClick } from '../../../../../components/ctaButtons/tracking';
import { saveCampaignInStore, saveProductInStore, readFinance, } from '../../../../utils/sessionStorage';
import { getProducts, getDefaultProduct } from '../../../../api';
import { prepareDefaultDataForProduct, generateFormData, generateFormSummary, escapeRegExp, getFinancingProductForProductId, } from './form-helperRethink';
import { getFormValues, renderSelectField, renderHiddenField, renderReadonlyFieldForSummary, renderRadioField as renderRadioFields, RenderTextField, } from './form-fieldsRethink';
import { getFSAGDefaultProduct, patchFormParameter, patchProductData, } from '../../../../utils/crs-helper';
import { deepCopy } from '../../../../../utils/object';
import { RadioWrapper, FormWrapper, RadioWrapperToOverwriteLegacyCSS, FormElementWrapper, ReadOnlyGroup, RateWrapper, WebCalcErrWrapper, WebCalcErrContainer, FormColumnWrapper, ReadOnlyColumn, ProductWrapper, HeadingWrapper, FinanceModalWrapper, CTAWrapper, } from './financeModal-stylesRethink';
import { InfoIcon } from './InfoIcon';
import { getActiveCampaigns } from '../../../../../components/finance/dynamic-finance/campaign-helper';
import { SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import { useDesktopOrMobileView } from '../../../../../hooks';
import FinanceRethinkCTAs from './FinanceRethinkCTAs';
import { FootnoteReferenceContextProvider } from '../../../../../components';
export const FinanceModalRethink = ({ fullVehicle, onClose, onError, setCalculationError, financeData, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { audiMarketContextService, getConfiguration, getEnvironmentConfig } = useServicesContext();
    const { svd } = useStockContext();
    const isMobileScreenSize = useDesktopOrMobileView('688px') === 'mobile';
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const scopesFromConfig = (_a = getConfiguration()) === null || _a === void 0 ? void 0 : _a.scopes;
    const interpretDisclaimerHtml = scopesFromConfig === null || scopesFromConfig === void 0 ? void 0 : scopesFromConfig.interpretDisclaimersTextStyle;
    const storeName = fullVehicle.basic.type.toUpperCase() === 'N' ? 'VTP_FINANCING_NC' : 'VTP_FINANCING_UC';
    const vehicleId = fullVehicle.basic.id;
    const endpointUrl = (_b = getEnvironmentConfig()) === null || _b === void 0 ? void 0 : _b.crsServiceBaseUrl;
    const currency = (_d = (_c = getConfiguration()) === null || _c === void 0 ? void 0 : _c.currency) !== null && _d !== void 0 ? _d : audiMarketContextService === null || audiMarketContextService === void 0 ? void 0 : audiMarketContextService.getContextItem('nemo.locale.currency');
    const currencyPattern = (_f = (_e = getConfiguration()) === null || _e === void 0 ? void 0 : _e.currencyPattern) !== null && _f !== void 0 ? _f : audiMarketContextService === null || audiMarketContextService === void 0 ? void 0 : audiMarketContextService.getContextItem('stockcar.custom.currency.pattern');
    const [webCalcErrorMsg, setWebCalcErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const i18n = {
        webcalcTechError: useI18n({
            id: 'stockcars.financing.calculation.error',
            defaultMessage: 'Its a techinical error, please try again later.',
        }),
        headline: useI18n({
            id: 'nemo.ui.sc.details.finance.form.headline',
            defaultMessage: '',
        }),
        headlineNew: useI18n({
            id: 'nemo.ui.sc.details.finance.form.headline.new',
            defaultMessage: '',
        }),
        headlineUsed: useI18n({
            id: 'nemo.ui.sc.details.finance.form.headline.used',
            defaultMessage: '',
        }),
        productHeadline: useI18n({
            id: 'nemo.ui.sc.details.finance.form.productheadline',
            defaultMessage: 'Für welche Finanzierungsoption interessieren sie sich?',
        }),
        formHeadline: useI18n({
            id: 'nemo.ui.sc.details.finance.form.dataheadline',
            defaultMessage: 'Bitte geben Sie Ihre Finanzierungsdaten an:',
        }),
        financeRateLabelSuffix: useI18n({
            id: 'nemo.ui.sc.details.finance.form.rate.label.suffix',
            defaultMessage: '',
        }),
        calculateButton: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.calculate',
            defaultMessage: 'neu berechnen',
        }),
        updateButton: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.update',
            defaultMessage: 'aktualisieren',
        }),
        disclaimerHeadline: useI18n({
            id: 'nemo.ui.sc.details.finance.form.disclaimer',
            defaultMessage: 'Disclaimer',
        }),
        helpPopup: useI18n({
            id: 'nemo.ui.sc.details.finance.form.help.label',
            defaultMessage: 'Weitere Informationen',
        }),
        calculationError: useI18n({
            id: 'nemo.ui.sc.details.finance.form.calculationError',
            defaultMessage: 'Calculation error',
        }),
        resetButton: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.reset',
            defaultMessage: 'Reset value',
        }),
        buyOnline: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.buyOnline',
            defaultMessage: 'Buy Online',
        }),
        close: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.close',
            defaultMessage: 'Close',
        }),
        contactDealer: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.contactDealer',
            defaultMessage: 'Contact Dealer',
        }),
        updateBtn: useI18n({
            id: 'nemo.ui.sc.details.finance.form.button.update',
            defaultMessage: 'Update',
        }),
    };
    if (!((_g = fullVehicle.detail) === null || _g === void 0 ? void 0 : _g.financingRequest)) {
        return null;
    }
    const productParameter = (financeData === null || financeData === void 0 ? void 0 : financeData.productParameter) || {};
    const formParameter = (financeData === null || financeData === void 0 ? void 0 : financeData.formParameter) || {};
    const financeCampaign = (financeData === null || financeData === void 0 ? void 0 : financeData.campaign) || {};
    const financingProduct = financeCampaign && Object.keys(financeCampaign).length
        ? getFinancingProductForProductId(financeData, vehicleId, financeCampaign.typeDetail)
        : {};
    const requestData = (_h = financeData === null || financeData === void 0 ? void 0 : financeData.vehicleData) === null || _h === void 0 ? void 0 : _h.default;
    const actualDefaultProductID = (_k = (_j = financeData === null || financeData === void 0 ? void 0 : financeData.vehicleData) === null || _j === void 0 ? void 0 : _j.default) === null || _k === void 0 ? void 0 : _k.Product['@ID'];
    const productRequestData = (_l = financeData === null || financeData === void 0 ? void 0 : financeData.vehicleData) === null || _l === void 0 ? void 0 : _l.product;
    const getDynamicProduct = (result) => {
        var _a, _b, _c;
        const summary = Array.isArray(result) && result.length > 0
            ? (_b = (_a = result[0]) === null || _a === void 0 ? void 0 : _a.Summaries) === null || _b === void 0 ? void 0 : _b.Summary
            : (_c = result === null || result === void 0 ? void 0 : result.Summaries) === null || _c === void 0 ? void 0 : _c.Summary;
        const fullSummary = summary === null || summary === void 0 ? void 0 : summary.find((item) => item['@Type'] === 'Full');
        const dymanicProduct = (fullSummary === null || fullSummary === void 0 ? void 0 : fullSummary.Title['#text'])
            ? fullSummary === null || fullSummary === void 0 ? void 0 : fullSummary.Title['#text']
            : fullSummary === null || fullSummary === void 0 ? void 0 : fullSummary.Title;
        return dymanicProduct;
    };
    let initialDefaultProductData;
    if (Object.keys(financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData).length > 0) {
        initialDefaultProductData = financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData;
    }
    else {
        initialDefaultProductData = Array.isArray(requestData === null || requestData === void 0 ? void 0 : requestData.Product)
            ? Object.assign({}, requestData === null || requestData === void 0 ? void 0 : requestData.Product[0]) : Object.assign({}, requestData === null || requestData === void 0 ? void 0 : requestData.Product);
    }
    const [productData, setProductData] = useState(requestData === null || requestData === void 0 ? void 0 : requestData.Product);
    const [rawProduct, setRawProduct] = useState();
    const [defaultProductData, setDefaultProductData] = useState(initialDefaultProductData);
    const [formData, setFormData] = useState(null);
    const [formSummaryData, setFormSummaryData] = useState(null);
    const [loadedFinanceData, setLoadedFinanceData] = useState(false);
    const [inputFields, setInputFields] = useState({});
    const [showUpdateButton, setShowUpdateButton] = useState(false);
    const [dynamicHeadlineProduct, setDynamicHeadlineProduct] = useState(null);
    const [intialSetup, setIntialSetup] = useState(false);
    const [isProductChanged, setIsProductChanged] = useState(false);
    useEffect(() => {
        loadProductData();
    }, [defaultProductData]);
    const fetchSummary = () => __awaiter(void 0, void 0, void 0, function* () {
        var _o, _p, _q;
        const financeDataFromStore = yield readFinance(storeName);
        const financeResponseData = ((_o = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing[vehicleId]) === null || _o === void 0 ? void 0 : _o.financeResponseData)
            ? (_p = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing[vehicleId]) === null || _p === void 0 ? void 0 : _p.financeResponseData
            : (_q = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing[vehicleId]) === null || _q === void 0 ? void 0 : _q.defaultResponse;
        const generatedFormSummary = generateFormSummary(financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response, currency, currencyPattern);
        setFormSummaryData(generatedFormSummary);
    });
    useEffect(() => {
        if (formData && !intialSetup) {
            calculate();
            setIntialSetup(true);
        }
    }, [formData, intialSetup]);
    const setFormValue = (formName, field, value) => {
        const data = Object.assign({}, inputFields);
        data[formName][field.id] = field.control.dataType === 'decimal' ? parseFloat(value) : value;
        setInputFields(data);
    };
    const getErrorMessage = (error) => {
        let message;
        if (error instanceof Error) {
            message = error.message;
        }
        else {
            message = String(error);
        }
        return message || i18n.webcalcTechError;
    };
    const loadProductData = () => __awaiter(void 0, void 0, void 0, function* () {
        let defaultRawData;
        try {
            if (defaultProductData['@ID'] === (financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData['@ID']) &&
                (financeData === null || financeData === void 0 ? void 0 : financeData.defaultResponse.Response) &&
                !isProductChanged) {
                defaultRawData = Object.assign({}, financeData === null || financeData === void 0 ? void 0 : financeData.defaultResponse.Response);
            }
            else {
                defaultRawData = yield getDefaultProduct(endpointUrl, Object.assign(Object.assign({}, requestData), {
                    Product: { '@ID': defaultProductData['@ID'] },
                }), fullVehicle.basic.id, storeName, trackingService, false);
            }
            const defaultDataForProduct = prepareDefaultDataForProduct(defaultRawData);
            const generatedFormData = generateFormData(defaultDataForProduct.Parameters, currency, currencyPattern);
            setInputFields(getFormValues(generatedFormData));
            setFormData(generatedFormData);
            setRawProduct(defaultRawData);
            setDynamicHeadlineProduct(getDynamicProduct(defaultRawData.Result));
            fetchSummary();
        }
        catch (error) {
            onError(getErrorMessage(error));
        }
    });
    const loadFinanceData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _r;
        let productDataInsideFn = productData;
        try {
            setLoadedFinanceData(true);
            if (productRequestData) {
                const products = yield getProducts(endpointUrl, (_r = fullVehicle.detail.financingProductsRequest) === null || _r === void 0 ? void 0 : _r.Request, fullVehicle.basic.id, storeName, trackingService, false);
                productDataInsideFn = products.Products.Product;
                let defaultProduct = getFSAGDefaultProduct(products);
                const storeDefaultProduct = financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData;
                if (Object.keys(storeDefaultProduct).length > 0) {
                    defaultProduct = storeDefaultProduct;
                }
                if (defaultProduct['@ID'] !== defaultProductData['@ID']) {
                    setDefaultProductData(defaultProduct);
                }
            }
            patchProductData(productDataInsideFn, requestData, productParameter, defaultProductData);
            const patchedFormParameter = patchFormParameter(defaultProductData, formParameter);
            if (patchedFormParameter) {
                setDefaultProductData(patchedFormParameter);
            }
            if (financeCampaign && Object.keys(financeCampaign).length) {
                setDefaultProductData(Object.assign(Object.assign({}, defaultProductData), { '@ID': financeCampaign.typeDetail, '@CampaignID': financeCampaign.campaignId }));
            }
            yield loadProductData();
            if (financeCampaign && Object.keys(financeCampaign).length) {
                productDataInsideFn = yield addCampaignAsProduct(Array.isArray(productDataInsideFn) ? productDataInsideFn : [productDataInsideFn]);
            }
            setProductData(productDataInsideFn);
        }
        catch (error) {
            onError(getErrorMessage(error));
        }
    });
    const addCampaignAsProduct = (productDataInsideFn) => __awaiter(void 0, void 0, void 0, function* () {
        const vehiclesActiveCampaigns = yield getActiveCampaigns(fullVehicle, getEnvironmentConfig(), svd, getConfiguration());
        if (!vehiclesActiveCampaigns.length) {
            saveCampaignInStore(vehicleId, storeName, {});
        }
        let product = financingProduct;
        product = Array.isArray(product) ? product[0] : product;
        if (product && product.Label) {
            vehiclesActiveCampaigns.forEach((campaign_, index) => {
                const financeProduct = deepCopy(product);
                financeProduct.Label = campaign_.filterText;
                financeProduct.value = campaign_.typeDetail;
                financeProduct['@ID'] = `${campaign_.typeDetail}-${campaign_.campaignId}`;
                if (!productParameter || (productParameter && productParameter['@CampaignID'])) {
                    financeProduct['@Default'] =
                        vehiclesActiveCampaigns.length >= 1 &&
                            campaign_.campaignId === financeCampaign.campaignId
                            ? 'Yes'
                            : 'No';
                    if (index === 0) {
                        productDataInsideFn.forEach((prod) => {
                            prod['@Default'] = 'No';
                        });
                    }
                }
                else {
                    productDataInsideFn.forEach((prod) => {
                        prod['@Default'] = 'No';
                    });
                    const currentProduct = productDataInsideFn.filter((prod) => prod['@ID'] === productParameter['@ID']);
                    if (currentProduct.length) {
                        currentProduct[0]['@Default'] = 'Yes';
                    }
                    financeProduct['@Default'] = 'No';
                }
                financeProduct.Campaign = financeCampaign.campaignId;
                productDataInsideFn.push(financeProduct);
            });
        }
        return productDataInsideFn;
    });
    const getFSAGRequestObject = (inputFormValues, currentProductData) => {
        const formValues = Object.values(inputFormValues).reduce((target, form) => {
            return Object.assign(Object.assign({}, target), form);
        }, {});
        const mappedFormValues = Object.keys(formValues)
            .filter((key) => !key.startsWith('$'))
            .map((fieldId) => {
            return {
                '@ID': fieldId,
                '#text': typeof formValues[fieldId] === 'number'
                    ? formValues[fieldId]
                    : escapeRegExp(formValues[fieldId]),
            };
        });
        const product = { '@ID': currentProductData['@ID'] };
        const request = Object.assign(Object.assign({}, requestData), { Product: Object.assign(Object.assign({}, product), { Parameter: [...mappedFormValues] }) });
        return request;
    };
    const calculate = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setWebCalcErrorMsg('');
        const formValues = Object.values(inputFields).reduce((target, form) => {
            return Object.assign(Object.assign({}, target), form);
        }, {});
        const mappedFormValues = Object.keys(formValues)
            .filter((key) => !key.startsWith('$'))
            .map((fieldId) => {
            return {
                '@ID': fieldId,
                '#text': typeof formValues[fieldId] === 'number'
                    ? formValues[fieldId]
                    : escapeRegExp(formValues[fieldId]),
            };
        });
        const product = { '@ID': defaultProductData['@ID'] };
        const request = Object.assign(Object.assign({}, requestData), { Product: Object.assign(Object.assign({}, product), { Parameter: [...mappedFormValues] }) });
        try {
            const rawProductFromApi = yield getDefaultProduct(endpointUrl, request, fullVehicle.basic.id, storeName, trackingService, false);
            const defaultDataForProduct = prepareDefaultDataForProduct(rawProductFromApi);
            const generatedFormData = generateFormData(defaultDataForProduct.Parameters, currency, currencyPattern);
            if (rawProductFromApi.Error) {
                if (typeof rawProductFromApi.Error.Description === 'object' &&
                    rawProductFromApi.Error.Description !== null) {
                    setWebCalcErrorMsg(rawProductFromApi.Error.Description['#text'] || '');
                }
                else if (typeof rawProductFromApi.Error.Description === 'string') {
                    setWebCalcErrorMsg(rawProductFromApi.Error.Description || '');
                }
                setCalculationError(true);
            }
            else {
                setInputFields(getFormValues(generatedFormData));
                setFormData(generatedFormData);
                fetchSummary();
                setRawProduct(rawProductFromApi);
                setLoading(false);
                update();
                setDynamicHeadlineProduct(getDynamicProduct(rawProductFromApi.Result));
                setCalculationError(false);
                setIsProductChanged(false);
            }
        }
        catch (error) {
            const errorMsg = getErrorMessage(error);
            setWebCalcErrorMsg(errorMsg);
            setLoading(false);
            setCalculationError(true);
        }
        setShowUpdateButton(true);
    });
    const update = (closeModal, trackUpdate = false) => {
        saveProductInStore(vehicleId, storeName, rawProduct, defaultProductData);
        if (trackUpdate)
            trackUpdateClick(trackingService, i18n.updateButton);
        if (closeModal) {
            if (webCalcErrorMsg) {
                resetFormOnClick();
            }
            onClose();
        }
    };
    if (!loadedFinanceData) {
        loadFinanceData();
        return null;
    }
    const renderDisclaimerText = (text) => {
        if (interpretDisclaimerHtml) {
            return React.createElement(DangerousElement, { html: text, as: "span" });
        }
        return React.createElement("span", null, text);
    };
    const resetFormOnClick = () => {
        setWebCalcErrorMsg('');
        loadProductData();
    };
    const useStockHeadlines = i18n.headlineNew.trim() !== '' || i18n.headlineUsed.trim() !== '';
    const isNewCar = fullVehicle.basic.type.toUpperCase() === 'N';
    const stockHeadline = isNewCar ? i18n.headlineNew : i18n.headlineUsed;
    const useDynamicHeadlines = useStockHeadlines && stockHeadline !== '';
    const { fields } = audiContentService.getContent();
    const { shiftCurrencySymbolLeftToRight, includeRateInSummaryBreakdown } = fields;
    const fsagRequest = getFSAGRequestObject(inputFields, defaultProductData);
    const trackButtonClick = (button, variant, trackingCode, btnName) => {
        trackClick(trackingService, button, variant, 'vtp-carInfo', fullVehicle.basic.id, trackingCode, btnName);
    };
    const footnoteReferenceServiceScopeManager = useServicesContext().getAdditionalService('audi-footnote-reference-service');
    const scopedFootnoteReferenceService = footnoteReferenceServiceScopeManager.getCustomScopeRefService('financeModal');
    return (React.createElement(FootnoteReferenceContextProvider, { footnoteReferenceServiceScopeManager: footnoteReferenceServiceScopeManager, customScope: scopedFootnoteReferenceService.getConsumerId() },
        React.createElement(FinanceModalWrapper, null,
            React.createElement(HeadingWrapper, null,
                React.createElement(Headline, { tag: "h1", variant: {
                        order: '3',
                        type: 'headline',
                        weight: 'normal',
                    } }, useDynamicHeadlines ? `${stockHeadline} ${dynamicHeadlineProduct}` : i18n.headline)),
            React.createElement(ProductWrapper, null,
                Array.isArray(productData) && productData.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(RadioWrapper, { legend: i18n.productHeadline }, productData.map((product) => (React.createElement(RadioWrapperToOverwriteLegacyCSS, { key: `product-section-${product['@ID']}` },
                        React.createElement(RadioButton, { "aria-label": useI18n({
                                id: `stockcars.financing.dynamic.overlay.arialabel.input.${product['@ID']}`,
                                defaultMessage: product.Label['#text']
                                    ? product.Label['#text']
                                    : product.Label,
                            }), onChange: () => {
                                setDefaultProductData(product);
                                setWebCalcErrorMsg('');
                                setIsProductChanged(true);
                            }, key: `${product['@ID']}`, value: product['@ID'], id: product['@ID'], name: "product", checked: product['@ID'] ===
                                (Array.isArray(defaultProductData) && defaultProductData.length > 1
                                    ? defaultProductData === null || defaultProductData === void 0 ? void 0 : defaultProductData.find((element) => actualDefaultProductID === element['@ID'])['@ID']
                                    : defaultProductData['@ID']), label: product.Label['#text'] ? product.Label['#text'] : product.Label }),
                        product.Description && (React.createElement(InfoIcon, { ariaLabel: useI18n({
                                id: `stockcars.financing.dynamic.overlay.arialabel.moreinfo.${product['@ID']}`,
                                defaultMessage: `${product['@ID']}`,
                            }), popupContent: getProductDescription(product.Description), key: `prodct-icon-button-${product.Label}`, iconSize: "md", alignment: "left" })))))))),
                !Array.isArray(productData) &&
                    typeof productData === 'object' &&
                    productData['Label'] && (React.createElement(React.Fragment, null,
                    React.createElement(RadioWrapper, { legend: i18n.productHeadline, key: i18n.productHeadline },
                        React.createElement(RadioWrapperToOverwriteLegacyCSS, null,
                            React.createElement(RadioButton, { "aria-label": useI18n({
                                    id: `stockcars.financing.dynamic.overlay.arialabel.input.${productData['@ID']}`,
                                    defaultMessage: productData['Label']['#text']
                                        ? productData['Label']['#text']
                                        : productData['Label'],
                                }), key: `${productData['@ID']}`, value: productData['@ID'], id: productData['@ID'], checked: productData['@ID'] ===
                                    (Array.isArray(defaultProductData) && defaultProductData.length > 1
                                        ? defaultProductData === null || defaultProductData === void 0 ? void 0 : defaultProductData.find((element) => actualDefaultProductID === element['@ID'])['@ID']
                                        : defaultProductData['@ID']), onChange: () => { }, name: "product", label: productData['Label']['#text']
                                    ? productData['Label']['#text']
                                    : productData['Label'] }),
                            productData['Description'] && (React.createElement(InfoIcon, { ariaLabel: useI18n({
                                    id: `stockcars.financing.dynamic.overlay.arialabel.moreinfo.${productData['@ID']}`,
                                    defaultMessage: `${productData['@ID']}`,
                                }), key: `prodct_${productData['Label']}`, popupContent: getProductDescription(productData['Description']), iconSize: "md", alignment: "left" }))))))),
            React.createElement("div", null,
                React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '1', style: 'bold' }, margin: [0, 0, SYS_SPACE_FIXED_300, 0], key: i18n.formHeadline }, i18n.formHeadline),
                React.createElement(FormWrapper, null,
                    React.createElement(FormColumnWrapper, null, (_m = formData === null || formData === void 0 ? void 0 : formData.data) === null || _m === void 0 ? void 0 : _m.map((form) => (React.createElement(React.Fragment, { key: `input-map-wrappper${form.name}` }, form.parameter
                        .filter((field) => field.control.type !== 'Label')
                        .map((field) => (React.createElement(FormElementWrapper, { key: `input-${field.id}` },
                        field.control.type === 'Select' && (React.createElement(React.Fragment, { key: `seperate-breakdown-fields-${form.label}` }, field.control.style === 'Radio'
                            ? renderRadioFields(field, form.name, inputFields, setFormValue, calculate, loading)
                            : renderSelectField(field, form.name, inputFields, setFormValue, calculate, loading, trackingService))),
                        field.control.type === 'Hidden' &&
                            renderHiddenField(field, form.name, inputFields),
                        field.control.type === 'Edit' && (React.createElement(RenderTextField, { field: field, formName: form.name, inputFields: inputFields, setFormValue: setFormValue, calculate: calculate, loading: loading, shiftCurrencySymbolLeftToRight: shiftCurrencySymbolLeftToRight })),
                        React.createElement(InfoIcon, { key: `form-icon-button${field.id}`, hideButton: !field.hasHelp && field.control.type !== 'Label', popupContent: field.help, iconSize: "md", ariaLabel: useI18n({
                                id: `stockcars.financing.dynamic.overlay.arialabel.moreinfo.${field.id}`,
                                defaultMessage: `${field.id}`,
                            }) })))))))),
                    React.createElement(ReadOnlyColumn, null,
                        React.createElement(ReadOnlyGroup, null, !webCalcErrorMsg ? (formSummaryData && (React.createElement(React.Fragment, null,
                            formSummaryData.map((summaryData) => {
                                return (React.createElement(React.Fragment, { key: `read-only-data-wrappper${summaryData.label}` },
                                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'bold' }, key: `read-only-${summaryData.label}` }, summaryData.label),
                                    summaryData.detail.map((summary) => (React.createElement(React.Fragment, { key: `read-only-${summary.id}-wrapper` }, renderReadonlyFieldForSummary(summary, i18n, loading, currency))))));
                            }),
                            !includeRateInSummaryBreakdown &&
                                formSummaryData.map((summaryData) => summaryData.detail
                                    .filter((item) => item.id === 'Rate')
                                    .map((summary) => (React.createElement(React.Fragment, { key: `rate-map-wrappper${summary.id}-rate` },
                                    React.createElement(Divider, { orientation: "horizontal", margin: [SYS_SPACE_FIXED_150, 0, SYS_SPACE_FIXED_150, 0] }),
                                    React.createElement(RateWrapper, null, renderReadonlyFieldForSummary(summary, i18n, loading, currency))))))))) : (React.createElement(React.Fragment, null,
                            React.createElement(WebCalcErrWrapper, null,
                                React.createElement(WebCalcErrContainer, null,
                                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '1', style: 'bold' }, className: "web-calc-error-headline" }, i18n.calculationError)),
                                React.createElement(WebCalcErrContainer, null,
                                    React.createElement("div", { style: { marginRight: '12px' } },
                                        React.createElement(Icon, { name: "caution", size: "s" })),
                                    React.createElement("div", null,
                                        React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' } },
                                            React.createElement(DangerousElement, { as: "p", html: webCalcErrorMsg })))),
                                React.createElement(TextButton, { "aria-label": i18n.resetButton, icon: "refresh", iconPosition: "leading", onClick: resetFormOnClick, size: "sm", title: i18n.resetButton, variant: "tertiary", "data-test-id": "reset_btn" }, i18n.resetButton)))))))),
            React.createElement(CTAWrapper, { isMobile: isMobileScreenSize },
                React.createElement(FinanceRethinkCTAs, { key: `${defaultProductData['@ID']}-ctas`, vehicle: fullVehicle.basic, isLoading: loading, fsagRequest: fsagRequest, hasWebCalcErrors: webCalcErrorMsg.length > 0, isMobileScreenSize: isMobileScreenSize, trackButtonClick: trackButtonClick }),
                showUpdateButton && (React.createElement(TextButton, { variant: "secondary", isFullWidth: isMobileScreenSize, "aria-label": i18n.updateBtn, isLoading: loading, disabled: Boolean(webCalcErrorMsg), onClick: () => {
                        update(true, true);
                    } }, i18n.updateButton)))),
        (formData === null || formData === void 0 ? void 0 : formData.disclaimer) && (React.createElement(React.Fragment, null,
            React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'bold' } }, renderDisclaimerText(i18n.disclaimerHeadline)),
            formData.disclaimer.productDisclaimer && (React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' } }, renderDisclaimerText(formData.disclaimer.productDisclaimer))),
            formData.disclaimer.globalDisclaimer && (React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' } }, renderDisclaimerText(formData.disclaimer.globalDisclaimer)))))));
};
function getProductDescription(description) {
    if (typeof description === 'object' && '#cdata-section' in description) {
        return description['#cdata-section'];
    }
    return description;
}
